import http from '@/api/request'
import { ElMessage } from 'element-plus'
import cookie from '@/utils/cookies'
import config from '@/config/index'

/**
 * 套餐关联试题 - --登录
 * @param data
 * @returns {*}
 */
export function getAuthTopicRelationPracticeList(data) {
  return http().post('/resource/auth/topic/relation/practice/list', data)
}

/**
 * 章节所在资源套餐 - --登录
 * @param data
 * @returns {*}
 */
export function getAuthChapterRelationPriceList(data) {
  return http().post('/resource/auth/chapter/relation/price/list', data)
}

/**
 * 资源套餐价格 - --未登录
 * @param data
 * @returns {*}
 */
export function getCoursePriceList(data) {
  return http().post('/resource/api/course/price/list', data)
}

/**
 * 资源套餐价格 - --登录
 * @param data
 * @returns {*}
 */
export function getAuthCoursePriceList(data) {
  return http().post('/resource/auth/course/price/list', data)
}

/**
 * 更新状态
 * @param data
 * @returns {*}
 */
export function videoCheck(params) {
  return http().get('/resource/auth/course/video/check', { params })
}

/**
 * 更新状态
 * @param data
 * @returns {*}
 */
export function videoCheckUpdate(params) {
  return http().get('/resource/auth/course/video/check/update', { params })
}

/**
 * 删除状态
 * @param data
 * @returns {*}
 */
export function videoCheckDelete(params) {
  return http().get('/resource/auth/course/video/check/delete', { params })
}

/**
 * 分类-资源条件查询 --未登录
 * @param data
 * @returns {*}
 */
export function getCourseList(data) {
  return http().post('/resource/api/course/page', data)
}

/**
 * 分类-资源条件查询 --登录
 * @param data
 * @returns {*}
 */
export function getAuthCourseList(data) {
  return http().post('/resource/auth/course/page', data)
}

/**
 * 查询资源信息详情 -- 未登录
 * @param data
 * @returns {*}
 */
export function getCourseView(data) {
  return http().get('/resource/api/course/view', { params: data })
}

/**
 * 查询资源信息详情 -- 登录
 * @param data
 * @returns {*}
 */
export function getAuthCourseView(data) {
  return http().post('/resource/auth/course/view', data)
}

/**
 * 校验用户是否有权限观看
 * @param data
 * @returns {*}
 */
export function checkState(data) {
  return http().get('/resource/auth/course/checkState', { params: data })
}

/**
 * 评论分页 -- 未登录
 * @param param
 * @param page
 * @param size
 * @returns {*}
 */
export function courseCommentPage(param = {}, page = 1, size = 10) {
  return http().post('/resource/api/goods/comment/page', { pageCurrent: page, pageSize: size, ...param })
}

/**
 * 评论添加
 * @param data
 * @returns {*}
 */
export function courseCommentSave(data) {
  return http().post('/resource/auth/goods/comment/save', data)
}

/**
 * 评论回复
 * @param data
 * @returns {*}
 */
export function courseCommentReplySave(data) {
  return http().post('/resource/auth/goods/comment/reply/save', data)
}

/**
 * 资源笔记列表 -- 未登录
 * @param param
 * @param page
 * @param size
 * @returns {*}
 */
export function courseNotesListData(param = {}, page = 1, size = 10) {
  return http().post('/resource/api/course/notes/page', { pageCurrent: page, pageSize: size, ...param })
}

/**
 * 资源笔记列表 -- 登录
 * @param param
 * @param page
 * @param size
 * @returns {*}
 */
export function courseAuthNotesListData(param = {}, page = 1, size = 10) {
  return http().post('/resource/auth/course/notes/page', { pageCurrent: page, pageSize: size, ...param })
}

/**
 * 查询资源资源列表 -- 登录
 * @param params
 * @returns {*}
 */
export function courseListCourseware(params) {
  return http().post('/resource/auth/course/list/courseware', params)
}

/**
 * 查询资源资源列表 -- 未登录
 * @param params
 * @returns {*}
 */
export function courseApiListCourseware(params) {
  return http().post('/resource/api/course/list/courseware', params)
}

/**
 * 获取学习资源信息-开始学习
 * @param data
 * @returns {*}
 */
export function courseAuthGetResource(data) {
  return http().post('/resource/auth/course/get/resource', data)
}

/**
 * 回放观看
 * @param data
 * @returns {*}
 */
export function coursePlayBackWatch(data) {
  return http().post('/resource/auth/course/play/back/watch', data)
}

/**
 * 回放观看
 * @param data
 * @returns {*}
 */
export function courseApiPlayBackWatch(data) {
  return http().post('/resource/api/course/play/back/watch', data)
}

/**
 * 保存学习进度
 * @param data
 * @returns {*}
 */
export function courseSaveAuthResource(data) {
  return http().post('/resource/auth/course/save', data)
}

/**
 * 培训店：播放原始事件上报（后端权威核算）
 * @param data
 * @returns {*}
 */
export function courseTrainPlayEvent(data) {
  return http().post('/resource/auth/course/train/play/event', data)
}

/**
 * 关页签/关浏览器等卸载场景：用 fetch keepalive 尽量把落点送出（axios 会被取消）
 * @returns {boolean} 是否已发起请求
 */
export function courseTrainPlayEventKeepalive(data) {
  if (!process.client) return false
  try {
    const token = cookie.getInClient(config.tokenName)
    const sid = config.trainShopId || cookie.getInClient('shopId')
    if (!token || !sid || !data || !data.studyId) return false
    const body = JSON.stringify({
      studyId: data.studyId,
      eventType: data.eventType || 'pause',
      positionSec: Math.floor(Number(data.positionSec) || 0),
      durationSec: data.durationSec != null ? Math.floor(Number(data.durationSec) || 0) : undefined,
      clientTs: data.clientTs || Date.now(),
      clientSeq: data.clientSeq != null ? Number(data.clientSeq) : undefined,
      clientType: data.clientType != null ? data.clientType : 1,
      playbackRate: data.playbackRate != null ? data.playbackRate : 1,
    })
    fetch('/gateway/resource/auth/course/train/play/event', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token,
        sid: String(sid),
      },
      body,
      keepalive: true,
      credentials: 'same-origin',
    }).catch(() => {})
    return true
  } catch (e) {
    return false
  }
}

/**
 * 添加笔记
 * @param data
 * @returns {*}
 */
export function courseAuthNotesSave(data) {
  return http().post('/resource/auth/course/notes/save', data)
}

/**
 * 资源笔记修改
 * @param data
 * @returns {*}
 */
export function courseAuthNotesEdit(data) {
  return http().put('/resource/auth/course/notes/edit', data)
}

/**
 * 资源笔记删除
 * @param params
 * @returns {*}
 */
export function courseAuthNotesDelete(params) {
  return http().delete('/resource/auth/course/notes/delete', { params })
}

/**
 * 取消公开-私密
 * @param data
 * @returns {*}
 */
export function courseAuthNotesEditOpenSet(data) {
  return http().put('/resource/auth/course/notes/edit/open/set', data)
}
/**
 * 图文课观看
 * @param params
 * @returns {*}
 */
export function courseViewImageText(params) {
  return http().post('/resource/auth/course/view/image/text', params)
}

/**
 * 素材信息预览
 * @param data
 * @returns {*}
 */
export function materialPreview(data) {
  return http().post('/resource/api/material/preview', data)
}

/**
 * 图文课观看 -- 未登录
 * @param params
 * @returns {*}
 */
export function courseViewImageTextApi(params) {
  return http().post('/resource/api/course/view/image/text', params)
}

/**
 * 查询专题资源目录列表 --- 未登录
 * @param params
 * @returns {*}
 */
export function courseSubjectMenuView(params) {
  return http().get('/resource/api/course/view/data', { params })
}

/**
 * 查询专题资源目录列表 --- 登录
 * @param params
 * @returns {*}
 */
// export function courseAuthSubjectMenuView(params) {
//   return http().get('/resource/auth/course/view/data', { params })
// }

export function courseAuthSubjectMenuView(params) {
  return http().get('/resource/auth/course/view/tree/data', { params })
}

/**
 * 查询专题资源二级目录列表 --- 未登录
 * @param params
 * @returns {*}
 */
export function courseApiSubjectMenuTreeView(params) {
  return http().get('/resource/api/course/view/tree/data', { params })
}

/**
 * 查询专题资源二级目录列表 --- 登录
 * @param params
 * @returns {*}
 */
export function courseAuthSubjectMenuTreeView(params) {
  return http().get('/resource/auth/course/view/tree/data', { params })
}

/**
 * 查询套餐资源列表
 * @param params
 * @returns {*}
 */
export function courseTopicMenuView(params) {
  return http().get('/resource/api/course/view/project/data', { params })
}

/**
 * 查询相应平台分享图
 * @returns {*}
 */
export function shopPicList() {
  return http().get('/base/api/shop/share/pic/list/pic', {})
}

/**
 * 查询相应平台分享图 -- 登录
 * @returns {*}
 */
export function shopAuthPicList() {
  return http().get('/base/auth/shop/share/pic/list/pic', {})
}

/**
 * 资源信息搜索
 * @param data
 * @returns {*}
 */
export function courseSearch(data) {
  return http().post('/resource/api/course/search', data)
}

/**
 * 查询专题下资源详情
 * @param data
 * @returns {*}
 */
export function projectPeriodView(data) {
  return http().post('/resource/api/course/get/project/period/view', data)
}

/**
 * 直播观看 -- 登录
 * @param data
 * @returns {*}
 */
export function courseLiveWatchUrl(data) {
  return http().post('/resource/auth/course/live/watch', data)
}

/**
 * 直播观看 -- 未登录
 * @param data
 * @returns {*}
 */
export function courseLiveWatchApi(data) {
  return http().post('/resource/api/course/live/watch', data)
}

/**
 *
 * @param data
 * @returns {*}
 */
export function courseLiveAuthWatchLeave(data) {
  return http().post('/resource/auth/course/live/leave', data)
}
/**
 * 获取资源下载链接 --登录
 * @param data
 * @returns {*}
 */
export function coursewareDownloadAuth(data) {
  return http().post('/resource/auth/course/download/courseware', data)
}

/**
 * 获取资源下载链接 --未登录
 * @param data
 * @returns {*}
 */
export function coursewareDownloadApi(data) {
  return http().post('/resource/api/course/download/courseware', data)
}

/**
 * 人脸识别接口 --未登录
 * @param data
 * @returns {*}
 */
export function userFaceIdApi(data) {
  return http().post('/scm/api/attendance/sign/record/check', data)
}

/**
 * 人脸识别接口 --登录
 * @param data
 * @returns {*}
 */
export function userFaceId(data) {
  return http().post('/scm/auth/attendance/sign/record/check', data)
}

/**
 * 看课活体检测-初始化（无底图 CloudAuth ID_PRO；有底图返回 viapi_liveness）
 * @param data { bizType, courseId, chapterId?, periodId?, scene?, certName?, certNo?, metaInfo, returnUrl, certifyUrlType? }
 * scene: WATCH=课中打卡（默认）；OPEN_COURSE=开课活体
 */
export function watchFaceInit(data) {
  return http().post('/scm/auth/attendance/sign/record/face/init', data)
}

/**
 * 看课活体检测-查询结果
 * @param data { certifyId }
 */
export function watchFaceQuery(data) {
  return http().post('/scm/auth/attendance/sign/record/face/query', data)
}

/**
 * 看课活体-VIAPI 自拍校验（有底图：DetectLivingFace + CompareFace）
 * @param data { bizType, courseId, chapterId?, periodId?, scene?, faceImageBase64?, faceImageUrl? }
 */
export function watchFaceViapiVerify(data) {
  return http().post('/scm/auth/attendance/sign/record/face/viapi/verify', data)
}

/**
 * 开课活体-状态（本登录会话是否已通过）
 * @param data { courseId }
 */
export function openCourseFaceStatus(data) {
  return http().post('/scm/auth/course/open/face/status', data)
}

/**
 * 人脸识别配置请求 --未登录
 * @param data
 * @returns {*}
 */
export function getUserFaceIdConfigApi(data) {
  return http().post('/scm/api/attendance/sign/record/check/view', data)
}

/**
 * 人脸识别配置请求 --登录
 * @param data
 * @returns {*}
 */
export function getUserFaceIdConfig(data) {
  return http().post('/scm/auth/attendance/sign/record/check/view', data)
}

/**
 * 预约直播-资源
 * @param params
 * @returns {*}
 */
export function courseAuthAppointment(params) {
  return http().get('/resource/auth/course/appointment/course', { params })
}

/**
 * 预约直播-资源 新
 * @param params
 * @returns {*}
 */
export function courseAuthLive(data) {
  return http().post('/resource/auth/course/live/book/save', data)
}

// 资源是否已过期
export function handleBeforeValid(course) {

  if (course.courseStatus === 3) {
    course.isCourseQuestion == 2 ?  ElMessage.error('考试截至时间已过期') : ElMessage.error('资源已过期')
    return false
  } else if (course.courseStatus === 2) {
    course.isCourseQuestion == 2 ? ElMessage.error('还未到考试时间') : ElMessage.error('资源未开课')
    return false
  } else if (course.courseStatus === 1) {
    ElMessage.error('资源尚未预约')
    return false
  } else {
    return true
  }
}

/**
 * 资源，试卷分类导航
 * @param params
 * @returns {*}
 */
export function getNavTypeList(params) {
  return http().get('/base/api/resource/nav/list', { params })
}

/**
 * 查询章节必修课
 * @param data
 * @returns {*}
 */
export function getCoursePeriodWatch(data) {
  return http().post('/resource/auth/course/period/watch', data)
}

/**
 * 视频链接单课反查所属专题（培训店填券用）
 * @param {{ id: string|number }} params
 */
export function courseParentSubject(params) {
  return http().get('/resource/api/course/parent/subject', { params })
}

/**
 * 查询用户预约直播 --登录
 * @returns {*}
 */
export function userReservationlive(params) {
  return http().get('/base/auth/page/web/detail', { params })
}

//立即支付合同信息
export function getContract(params) {
  return http().post('/resource/auth/shop/contract/get', params)
}

//保存合同信息
export function saveContract(data) {
  return http().post('/resource/auth/shop/user/contract/save', data)
}
